<script lang="ts" setup>
  import { fetchMedia } from '@/shared/lib';
  import { DSCVR_STATIC_ASSETS_CDN_URL } from '@/common';
  import { useI18n } from 'vue-i18n';
  import HeaderDialog from '../../ui/Header.vue';

  const { t } = useI18n({
    useScope: 'global',
  });
</script>

<template>
  <header-dialog class="-top-[15%] md:-top-20">
    <img
      :src="
        fetchMedia(
          `${DSCVR_STATIC_ASSETS_CDN_URL}/onboarding/rotating-planets.gif`,
        )
      "
      :alt="t('onboarding.interest.title')"
      class="w-39 h-auto"
    />
  </header-dialog>
</template>
